export default __webpack_public_path__ + "static/media/image_15.1b9576f1.jpg";